import React, { Fragment } from 'react';

import TableHeaderWithTooltip from './TableHeaderWithTooltip';

import { parseLocaleNumber } from 'Helpers/currencyFormat';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

export default function InputsClientsGroups(props) {
    const groupsKeys = { local: $t('Local'), national: $t('National'), international: $t('International') };

    const rows = [
        { transport: $t('Transport (Internal)') },
        { accommodation: $t('Accommodation') },
        { f_and_b: $t('F&B (excluding event F&B)') },
        { entertainment: $t('Entertainment (excl tickets for the event)') },
        { shopping: $t('Shopping') },
    ];

    const changeInput = (e, group, subGroup, rowKey, key = null) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;

        if (key) {
            data[group][subGroup][rowKey][key] = val;
        } else {
            data[group][subGroup][rowKey] = val;
        }

        props.changeHandler(data);
    };

    const changeSelect = (e, group, subGroup, rowKey, key) => {
        const data = JSON.parse(JSON.stringify(props.data));
        data[group][subGroup][rowKey][key] = e.target.value === '1';

        props.changeHandler(data);
    };

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">{$t('Economic - Client Groups')}</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr className="tw-uppercase *:tw-border-r-2 *:!tw-font-extrabold *:!tw-pb-1.5">
                            <th colSpan={4}>{$t('1. Visitors')}</th>
                            <th colSpan={4}>{$t('Inputs')}</th>
                            <th colSpan={3}>{$t('Outputs')}</th>
                        </tr>
                        <tr className="*:!tw-pt-1.5">
                            <th className="tw-min-w-38">{$t('Category')}</th>
                            <th className="tw-min-w-48">{$t('Percentage by origin')}</th>
                            <th className="tw-min-w-48">
                                {$t('Duration of stay')}
                                <br />({$t('days')})
                            </th>
                            <th className="tw-min-w-40 tw-border-r-2">{$t('Expenditure type')}</th>
                            <th className="tw-min-w-40">
                                {$t('OC')}
                                <br />
                                {$t('Expenditure')}
                                <br />
                                {$t('Yes / No')}
                            </th>
                            <th className="tw-min-w-48">{$t('Average spend per person per day')}</th>
                            <th className="tw-min-w-28">
                                {$t('Indirect')}
                                <br />
                                {$t('Multiplier')}
                            </th>
                            <th className="tw-min-w-28 tw-border-r-2">
                                {$t('Induced')}
                                <br />
                                {$t('Multiplier')}
                            </th>
                            <TableHeaderWithTooltip
                                className="tw-min-w-32"
                                content={$t('Total Direct')}
                                tooltipContent={$t('The direct effects from the initial spending creates additional activity in the local economy.')}
                            />
                            <TableHeaderWithTooltip
                                className="tw-min-w-32"
                                content={$t('Total Indirect')}
                                tooltipContent={$t(
                                    'Indirect effects are the results of business-to-business transactions indirectly caused by the direct effects. Businesses initially benefiting from the direct effects will subsequently increase spending at other local businesses. The indirect effect is a measure of this increase in business-to-business activity (not including the initial round of spending, which is included in the direct effects.',
                                )}
                            />
                            <TableHeaderWithTooltip
                                className="tw-min-w-32 tw-border-r-2"
                                content={$t('Total Induced')}
                                tooltipContent={$t(
                                    'Induced effects are the results of increased personal income caused by the direct and indirect effects. Businesses experiencing increased revenue from the direct and indirect effects will subsequently increase payroll expenditures (by hiring more employees, increasing payroll hours, raising salaries, etc.). Households will, in turn, increase spending at local businesses. The induced effect is a measure of this increase in household-to-business activity.',
                                )}
                            />
                        </tr>
                    </thead>
                    <tbody className="tw-align-bottom">
                        {props.visitorsSections.map((section) => {
                            let group = Object.keys(section)[0];
                            let name = Object.values(section)[0];

                            return (
                                <Fragment key={group}>
                                    {Object.keys(groupsKeys).map((groupKey, index) => {
                                        return (
                                            <Fragment key={group + '_' + groupKey}>
                                                <tr key={group + '_' + groupKey} className="tw-font-semibold">
                                                    <td className="!tw-border-r-0">{name}</td>
                                                    <td colSpan={100}>{groupsKeys[groupKey]}</td>
                                                </tr>

                                                {rows.map((row, rowIndex) => {
                                                    let rowKey = Object.keys(row)[0];
                                                    let rowTitle = Object.values(row)[0];

                                                    let total = props.centralAssumption[group].total_number;
                                                    let percent = props.centralAssumption[group][groupKey + '_percent'];
                                                    let groupTotal = (total * percent) / 100;
                                                    let durationOfStay = props.data[group][groupKey].duration_of_stay;
                                                    let averageStayPerPersonPerDay = props.data[group][groupKey][rowKey].average_spend_per_person_per_day;
                                                    let totalDirect = groupTotal * durationOfStay * averageStayPerPersonPerDay;
                                                    let totalIndirect = (totalDirect * props.data[group][groupKey][rowKey].indirect_percent) / 100;
                                                    let totalInduced = (totalDirect * props.data[group][groupKey][rowKey].induced_percent) / 100;

                                                    return (
                                                        <tr className="!tw-bg-white" key={group + '_' + groupKey + '_' + rowKey}>
                                                            <td>{rowIndex === 0 && props.format(total)}</td>
                                                            <td>
                                                                <span className="tw-font-semibold">{rowIndex === 0 && percent + '%'}</span>
                                                                <span className="tw-text-xs tw-text-charcoal-75 tw-font-medium tw-ml-1">
                                                                    {rowIndex === 0 && '(' + props.format(groupTotal) + ')'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {rowIndex === 0 && (
                                                                    <NumberFormat
                                                                        thousandSeparator={true}
                                                                        inputMode="numeric"
                                                                        className="text-input"
                                                                        value={props.data[group][groupKey].duration_of_stay}
                                                                        onChange={(e) => {
                                                                            changeInput(e, group, groupKey, 'duration_of_stay');
                                                                        }}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td style={{ width: '20%' }}>{rowTitle}</td>
                                                            <td>
                                                                <select
                                                                    className="select-input"
                                                                    value={props.data[group][groupKey][rowKey].os_expenditure ? '1' : '0'}
                                                                    onChange={(e) => {
                                                                        changeSelect(e, group, groupKey, rowKey, 'os_expenditure');
                                                                    }}
                                                                >
                                                                    <option value="0">No</option>
                                                                    <option value="1">Yes</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <NumberFormat
                                                                    thousandSeparator={true}
                                                                    inputMode="numeric"
                                                                    className="text-input"
                                                                    value={props.data[group][groupKey][rowKey].average_spend_per_person_per_day}
                                                                    onChange={(e) => {
                                                                        changeInput(e, group, groupKey, rowKey, 'average_spend_per_person_per_day');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                    <input
                                                                        className="text-input"
                                                                        type={'number'}
                                                                        value={props.data[group][groupKey][rowKey].indirect_percent}
                                                                        min="0"
                                                                        max="100"
                                                                        onChange={(e) => {
                                                                            changeInput(e, group, groupKey, rowKey, 'indirect_percent');
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                    <input
                                                                        className="text-input"
                                                                        type={'number'}
                                                                        value={props.data[group][groupKey][rowKey].induced_percent}
                                                                        min="0"
                                                                        max="100"
                                                                        onChange={(e) => {
                                                                            changeInput(e, group, groupKey, rowKey, 'induced_percent');
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="!tw-bg-charcoal-50 tw-text-white">{props.format(totalDirect)}</td>
                                                            <td className="!tw-bg-blue/90 tw-text-white">{props.format(totalIndirect)}</td>
                                                            <td className="!tw-bg-charcoal/90 tw-text-white">{props.format(totalInduced)}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </Fragment>
                                        );
                                    })}
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
